import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Fade from '@mui/material/Fade';
import { PageWrapper, PartnerStrip, DMSALogo, theme } from '@omnigenbiodata/ui';

import { useStyles } from './component.styles';
import { PARTNER_LOGOS } from '../../core/constants/content.constant';
import ANIMATIONS from '../../core/constants/animations.constant';

interface MainLayoutProps {
  children: ReactNode;
  title?: string;
}

function MainLayout({ children, title = '' }: MainLayoutProps) {
  const { classes } = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <PageWrapper>
      <div className={classes.header}>
        <Link to="/" className={classes.logo}>
          <DMSALogo size={isMobile ? 'responsive' : 'md'} />
        </Link>
      </div>

      {title && (
        <Typography className={classes.MainName} variant="h2" component="h1" align="center">
          {title}
        </Typography>
      )}
      <Fade in timeout={ANIMATIONS.duration}>
        <div className={classes.content}>{children}</div>
      </Fade>
      <div className={classes.footer}>
        <PartnerStrip logos={PARTNER_LOGOS} />
      </div>
    </PageWrapper>
  );
}

export default MainLayout;
